@if (template) {
<div class="dialog-confirmation dialog">
    <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>
}


<ng-template #supCategory>
    <div mat-dialog-title>
        <h2>Suppression d'une catégorie</h2>
    </div>
    <mat-dialog-content>
        <p>Comfirmer la suppression de la catégorie {{data.category?.label}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex flex-row justify-content-end">
        <button class="btn btn-light" mat-dialog-close>Annuler</button>
        <button class="btn btn-danger" (click)="dialogRef.close(true)">Confirmer la
            suppression</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #supMission>
    <div mat-dialog-title>
        <h2>Suppression d'une mission</h2>
    </div>
    <mat-dialog-content>
        <p>Comfirmer la suppression de la mission {{data.category?.label}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex flex-row justify-content-end">
        <button class="btn btn-light" mat-dialog-close>Annuler</button>
        <button class="btn btn-danger" (click)="dialogRef.close(true)">Confirmer la
            suppression</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #supEvent>
    <div mat-dialog-title>
        <h2>Suppression de l'événement</h2>
    </div>

    <div mat-dialog-content>
        <p>La suppression de l'événement entrainera la suppression de l'ensemble des données associées. Cette action est
            IRREVERSIBLE!</p>
        <ul>
            <li>L'événement</li>
            <li>Les catégories associés</li>
            <li>Les éléments de personalisation</li>
            <li>Le parcours et les donées associés</li>
            <li>Les points</li>
            <li>Les participants</li>
            <li>Les classements</li>
            <li>Les services associés à la course</li>
        </ul>

        <div>
            <label for="suppRaceConfirmation">Etes-vous certains de vouloir supprimer l'événement?</label>
            <select [(ngModel)]="suppRace" id="suppRaceConfirmation">
                <option value="Y">Je confirme la suppression</option>
                <option value="N">Non</option>
            </select>
        </div>


    </div>

    <div mat-dialog-footer>
        <button class="btn btn-danger" (click)="dialogRef.close(true)" [disabled]="suppRace === 'N'">Confirmer la
            suppression</button>
    </div>
</ng-template>


<ng-template #supRace>
    <div mat-dialog-title>
        <h2>Suppression d'une course</h2>
    </div>

    <div mat-dialog-content>
        <p>La suppression d'une course entrainera la suppression de l'ensemble des données associées. Cette action est
            IRREVERSIBLE!</p>
        <ul>
            <li>La course</li>
            <!-- <li>Les coureurs</li>
            <li>Les points de passages des coureurs</li> -->
            <li>Les liens entre les points de contrôle et la course</li>
            <li>L'heure de départ</li>
            <li>Les services associés à la course</li>
        </ul>

        Si vous ne transferez pas les coureurs vers une autre course alors ils seront supprimés et leurs points de
        passage également.


        <div>
            <label for="changeRunner">Déplacer les coureurs vers une autre course</label>
            <select [(ngModel)]="changeRunnerRace" id="changeRunner">
                <option value="N">Non</option>
                @for (race of races$ | async; track $index) {
                <option [value]="race.id">{{race.name}}</option>
                }
            </select>
        </div>


        <div>
            <label for="suppRaceConfirmation">Etes-vous certains de vouloir supprimer le parcours?</label>
            <select [(ngModel)]="suppRace" id="suppRaceConfirmation">
                <option value="Y">Je confirme la suppression</option>
                <option value="N">Non</option>
            </select>
        </div>


    </div>

    <div mat-dialog-footer>
        <button class="btn btn-danger" (click)="deleteRace()" [disabled]="suppRace === 'N'">Confirmer la
            suppression</button>
    </div>
</ng-template>